import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal }                    from '@ng-bootstrap/ng-bootstrap';
import { Transition }                  from '@uirouter/core';
import { UIRouter }                    from '@uirouter/core';

import { ApiService }      from '../api/api.service';
import { CompanyService }  from '../companies/company.service';
import { EventBusService } from '../core/services/event-bus.service';
import { SessionService }  from '../sessions/session.service';
import { TableService }    from '../table/table.service';

import { PrintJobsComponent }   from './jobs/transaction-center.jobs.print.component';
import { SendBulkSmsComponent } from './jobs/transaction-center.jobs.send-bulk-sms.component';

@Component({
  selector   : 'wor-transaction-center',
  template: require('./transaction-center.component.html')
})
export class TransactionCenterComponent implements OnInit, OnDestroy {
  filters = { value: '' };

  private deregisterHook: Function;

  constructor (
    private apiService: ApiService,
    private companyService: CompanyService,
    private eventBusService: EventBusService,
    private modalService: NgbModal,
    public sessionService: SessionService,
    private tableService: TableService,
    private uiRouter: UIRouter
  ) {}

  ngOnInit (): void {
    this.deregisterHook = this.uiRouter.transitionService.onStart(
      { to: 'app.transaction-center.**' },
      (transition: Transition) => {
        const cache = this.tableService.getCacheForTable(transition.to().data.tableCacheKey);
        this.filters.value = cache.filtering.value || '';
      }
    );
  }

  ngOnDestroy (): void {
    if (this.deregisterHook) {

      this.deregisterHook();

      };

    }

  onFilterChanged (): void {


    this.eventBusService.broadcast('searchFilterChanged', this.filters.value);


  }

  clearFilter (): void {


    this.filters.value = '';


    this.onFilterChanged();


  }

  createNew (): void {
    const tab = this.uiRouter.stateService.current.name.replace('app.transaction-center.', '');

    switch (tab) {


      case 'bookings':    this.uiRouter.stateService.go('app.event'); break;
      case 'inspections': this.uiRouter.stateService.go('app.inspection'); break;
      case 'jobs':        this.uiRouter.stateService.go('app.invoice'); break;
      case 'orders':      this.uiRouter.stateService.go('app.purchase-order'); break;
      case 'vendor-invoices': this.uiRouter.stateService.go('app.vendor-invoice'); break;


    }
  }

  isTab(tab: string): boolean {


    return this.uiRouter.stateService.current.name === `app.transaction-center.${tab}`;


  }

  printJobsForDate (): void {


    this.modalService.open(PrintJobsComponent).result.catch(() => {});


  }

  sendBulkSMS (): void {
    Promise.all([
      this.apiService.get('/system/job_filter_constraint_types'),
      this.apiService.get('/system/filter_job_status_types'),
      this.companyService.getDefaultMessages()
    ]).then(([constraints, statusTypes, messageSettings]) => {
      const modalRef = this.modalService.open(SendBulkSmsComponent, {
        windowClass: 'lg-modal flip-container'
      });
      modalRef.componentInstance.constraints     = constraints;
      modalRef.componentInstance.statusTypes      = statusTypes;
      modalRef.componentInstance.messageSettings  = messageSettings;
    });
  }
}
